import { useEffect } from "react";
import { useSite } from "@/lib/content";

/**
 * Keeps document.title + meta description/keywords in sync with the site
 * content stored in Mongo, so the admin can tweak SEO without touching code.
 */
function setMeta(name, value, attr = "name") {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export default function SeoHead() {
  const { content } = useSite();
  useEffect(() => {
    if (content?.seo_title) document.title = content.seo_title;
    setMeta("description", content?.seo_description);
    setMeta("keywords", content?.seo_keywords);
    setMeta("og:title", content?.seo_title, "property");
    setMeta("og:description", content?.seo_description, "property");
    setMeta("twitter:title", content?.seo_title);
    setMeta("twitter:description", content?.seo_description);
  }, [content?.seo_title, content?.seo_description, content?.seo_keywords]);
  return null;
}
